import { Models } from "@rematch/core";
import { rootState } from "./rootState";
export interface RootModel extends Models<RootModel> {
  rootState: typeof rootState;
}
export const models: RootModel = { rootState };
